import { convertPropertyValueToFieldValue } from 'automation-ui-action-features/actions/extension/utils/convertPropertyValueToFieldValue';
import { getValueTypeFromFieldDefinition } from 'automation-ui-action-features/actions/extension/utils/getValueTypeFromFieldDefinition';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
export const fieldDefinitionToMetadataField = ({
  fieldDefinition,
  ignoreDefaultValue = false
}) => {
  const {
    defaultValue,
    typeDefinition: {
      name,
      fieldType
    }
  } = fieldDefinition;
  const formattedDefaultValue = defaultValue && !ignoreDefaultValue ? convertPropertyValueToFieldValue(
  // @ts-expect-error `type` values aren't 1:1, but incompatible type ENROLLMENT_DATASET_COLUMN is WIP and won't be used here
  new PropertyValue(defaultValue)) : undefined;
  return {
    fieldKey: name,
    fieldValue: formattedDefaultValue || {
      valueType: getValueTypeFromFieldDefinition(fieldDefinition),
      value: fieldType === 'booleancheckbox' ? 'false' : null
    }
  };
};